/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";
import { labels } from "../../util/DataObject";

const TransactionsLabels = (props) => {
  const history = useHistory();
  const [zPos, setZPos] = useState(45)
  const [disabled, setDisabled] = useState(true);
  const [form, setForm] = useState({ uuid_tx: "", labels: [] });
  const [error, setErrors] = useState({ uuid_tx: "", labels: [] });

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const init = () => {
    let d = {
      uuid_tx: "", labels: [] 
    };
    setDisabled(true);
    setForm(JSON.parse(JSON.stringify(d)));
  };

  const send = async () => {
    props.changeLoader(true);
    setZPos(-1)
    let data = form;

    let request = await API.service( "transactionsLabels", data, props.pos, props.changeAlert, props.changeLoader, history );
    if ( request.status === 200 && request.data.data.response === "OK") {
      closelightbox();
      props.changeAlert(true, "success", "Registro creado con éxito");
      props.changeLoader(false);
      setZPos(45)
    } else {
      let detail = request.data.data.message;
      props.changeAlert(true, "error", "Error al etiquetar transacción, " + detail);
      props.changeLoader(false);
      setZPos(45)
    }
    props.changeLoader(false);
    setZPos(45)
  };

  const changeValue = (field, e) => {
    let f = form;
    let er = error;

    if (field) {
      if(field === "labels"){
        f[field].push(e.target.value)
      }else{
        f[field] = e.target.value;

      }
      if (!e.target.value) {
        er[field] = "Dato obligatorio";
      } else {
        er[field] = "";
      }
    }

    setForm(JSON.parse(JSON.stringify(f)));
    setErrors(JSON.parse(JSON.stringify(er)));
    validateForm(f, er);
  };

  const validateForm = (f, err) => {
    if (f["uuid_tx"] && !err["labels"]) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle>
          <span>
            Etiquetar Transacción
            <p id="subtitle_2">Etiquetar transacciones de depósitos en garantía</p>
          </span>
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>
        
        <DialogContent sx={{paddingTop: "5px !important"}}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                label="UUID Tx" value={form.uuid_tx} onChange={changeValue.bind(this, "uuid_tx")} error={error.uuid_tx !== ""} helperText={error.uuid_tx ? error.uuid_tx : ''} size="small" fullWidth />
            </Grid>
            <Grid item xs={6}>
              <TextField
                label="Label" value={form.labels || ""} onChange={changeValue.bind(this, "labels")} select size="small" fullWidth >
                {labels.map((i) => {
                  return (<MenuItem key={i.key} value={i.key}>{i.label}</MenuItem>);
                })}
              </TextField>
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>    
          <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>     
          <Button disabled={disabled} variant="contained" onClick={send.bind(this)} >Etiquetar</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>
  );
};

export default TransactionsLabels;
